import React from "react";
import StepHeader from "../StepHeader";
import RHFTagInput from "@/components/form/RHFTagInput";
import RequiredMark from "@/components/ui/RequiredMark";
import { languageFieldRequirements } from "@/utils/languageRequirements";
import { cn } from "@/lib/utils";

// `languagesSlot(disabled, required)` — optional render-prop replacing the
// languages tag input with a richer editor (the paired dropdowns). The label,
// the section's required marker and the lock state stay owned here; only the
// control is delegated.
//
// `required` is `{ language, proficiency }`, derived here so the pages that
// render the editor do not each re-derive it — six call sites, one rule. A
// caller that ignores the second argument keeps working unchanged, which is
// what the four admin editors do: they edit a candidate's profile rather than
// an application, so no job decides what they must fill in.
const StepSkills = ({ mandatoryFields = [], lockedSections = [], disabled = false, languagesSlot }) => {
  const isSkillsRequired = mandatoryFields.some((f) => f === "skills" || f === "skills.list" || f === "list");
  // Both halves, not just the language. The two keys go mandatory independently
  // — a job naming "English, any level" turns on only the first — but the
  // SECTION is required whenever either is, so the marker here is an OR. Which
  // of the two halves is required shows on the editor's own field labels.
  const languageRequirements = languageFieldRequirements(mandatoryFields);
  const isLanguagesRequired = languageRequirements.language || languageRequirements.proficiency;
  const skillsLocked = disabled || lockedSections.includes("skills");
  const languagesLocked = disabled || lockedSections.includes("languages");

  return (
    <div>
      <StepHeader title="Skills & Language" />

      <div className="px-5 space-y-6">
        <div>
          <label className={cn("block text-sm mb-1.5 text-text-secondary")}>
            Skills
            {isSkillsRequired && <RequiredMark />}
          </label>
          <RHFTagInput name="skills.list" placeholder="e.g. Leadership, Communication" disabled={skillsLocked} />
        </div>

        <div>
          <label className={cn("block text-sm mb-1.5 text-text-secondary")}>
            Language &amp; Proficiency
            {isLanguagesRequired && <RequiredMark />}
          </label>
          {languagesSlot ? (
            languagesSlot(languagesLocked, languageRequirements)
          ) : (
            <RHFTagInput name="skills.languages" placeholder="e.g. English, French" disabled={languagesLocked} />
          )}
        </div>
      </div>
    </div>
  );
};

export default StepSkills;
